import { Box } from '@betterment/samba-react';
import { useNavigate } from 'react-router-dom';

import EmployerFourOhOneKContributions from './EmployerFourOhOneKContributions';
import FourOhOneKContributions from './FourOhOneKContributions';

import { WorkflowLayout } from '../Shared/layout/WorkflowLayout';

const FourOhOneKContributionsWrapper: React.FC<React.PropsWithChildren> = () => {
  const navigate = useNavigate();

  const navigateToPreviousPage = () => {
    void navigate(-1);
  };

  return (
    <WorkflowLayout
      pageTitle="401(k) contribution details"
      workflowTitle="401(k) contribution details"
      onClose={navigateToPreviousPage}
    >
      <Box css={{ width: { md: 'container.large' } }}>
        <FourOhOneKContributions />
        <EmployerFourOhOneKContributions />
      </Box>
    </WorkflowLayout>
  );
};

export default FourOhOneKContributionsWrapper;
